/**
 * The time range of a promotion where Faire pays for or refunds duties for U.K. and E.U. retailers. * https:www.notion.so/faire/Duties-Refund-Promo-f4fbf388028940599b09f477e22ebbd8 * @deprecated This setting is in the process of being cleaned up. Do not add new references to it.
 */
export const FREE_DUTIES_PROMO_TIME_RANGE = 'FREE_DUTIES_PROMO_TIME_RANGE';
